export const TECH_COLORS = [
  '#2563eb', '#16a34a', '#db2777', '#ea580c', '#7c3aed',
  '#0891b2', '#ca8a04', '#dc2626', '#4f46e5', '#059669',
];

export const UNASSIGNED_COLOR = '#6b7280';

export const BACKLOG_SECTIONS = [
  { id: 'overdue', label: 'Overdue', accent: 'border-l-red-500 bg-red-50/50' },
  { id: 'due_now', label: 'Due this month', accent: 'border-l-amber-500 bg-amber-50/50' },
  { id: 'repair', label: 'Repairs', accent: 'border-l-orange-500 bg-orange-50/50' },
  { id: 'cspire', label: 'CSpire', accent: 'border-l-purple-500 bg-purple-50/50' },
  { id: 'franklin', label: 'Franklin', accent: 'border-l-emerald-500 bg-emerald-50/50' },
];

export const SOURCE_BADGE = {
  contract: { label: 'Contract', className: 'bg-slate-100 text-slate-700' },
  repair: { label: 'Repair', className: 'bg-orange-100 text-orange-800' },
  cspire: { label: 'CSpire', className: 'bg-purple-100 text-purple-800' },
  franklin: { label: 'Franklin', className: 'bg-teal-100 text-teal-800' },
};

export const PREFERRED_TECHS_KEY = 'preferredTechnicians';

const isRegularContractDueItem = (item) => item.source !== 'cspire' && item.subgroup !== 'cspire_unassigned';

export const groupBacklogItems = (items) => ({
  overdue: items.filter((i) => isRegularContractDueItem(i) && (i.dueBucket === 'overdue' || i.subgroup === 'overdue')),
  due_now: items.filter((i) => isRegularContractDueItem(i) && (i.dueBucket === 'due_now' || i.subgroup === 'due_now')),
  repair: items.filter((i) => i.subgroup === 'repair_queue'),
  cspire: items.filter((i) => i.subgroup === 'cspire_unassigned'),
  franklin: items.filter((i) => i.subgroup === 'franklin_needs_service'),
});

export const buildTechColorMap = (technicians) => {
  const map = {};
  technicians.forEach((tech, i) => {
    map[tech.id] = TECH_COLORS[i % TECH_COLORS.length];
  });
  return map;
};

export const getPreferredTechnicianIds = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(PREFERRED_TECHS_KEY) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

export const technicianName = (tech) =>
  tech ? [tech.firstName, tech.lastName].filter(Boolean).join(' ').trim() || 'Technician' : 'Unassigned';

/** Visit progress buckets for the Today dispatch view */
export const VISIT_BUCKET = {
  done: 'done',
  active: 'active',
  remaining: 'remaining',
};

export const VISIT_BUCKET_META = {
  done: {
    label: 'Done',
    dotClass: 'bg-emerald-500',
    rowClass: 'opacity-70',
    icon: 'check',
  },
  active: {
    label: 'In progress',
    dotClass: 'bg-primary-500 animate-pulse',
    rowClass: 'bg-primary-50 ring-1 ring-inset ring-primary-200',
    icon: 'active',
  },
  remaining: {
    label: 'Remaining',
    dotClass: 'border-2 border-gray-300 bg-surface',
    rowClass: '',
    icon: 'pending',
  },
};

export const formatLocationAge = (recordedAt) => {
  if (!recordedAt) return null;
  const ms = Date.now() - new Date(recordedAt).getTime();
  if (ms < 0) return 'just now';
  const minutes = Math.floor(ms / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};
